import React, { ReactElement, useState } from "react";
import ActionButton from "../../components/Buttons/ActionButton";

import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/icons/console.svg";
import { ReactComponent as DragIcon } from "../../assets/icons/drag_indicator.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as AddItemIcon } from "../../assets/icons/add.svg";
import { ReactComponent as PowerIcon } from "../../assets/icons/power.svg";
import { ReactComponent as RestartIcon } from "../../assets/icons/replay.svg";
import { ReactComponent as RebootIcon } from "../../assets/icons/rotate_right.svg";

import { NavLink } from "react-router-dom";
import AddButton from "../../components/Buttons/AddButton";
import {
  useDevice,
  useDeviceGroup,
  useDeviceGroups,
  useDevices,
  useDeviceTypes,
} from "../../Api/newSockets.api";
import Tooltip from "../../components/Tooltip/Tooltip";
import useCheckMobileScreen from "../../hooks/useCheckScreen";
import { toast, ToastContainer } from "react-toastify";
import { DeviceTypeId } from "../../constants/deviceTypes";

type Props = {
  children?: any;
  title?: string;
  did: string;
  onClick?: any;
  status?: boolean;
};

const GroupListItem = (props: Props) => {
  // const { deviceGroups } = useDevices();
  const {
    deleteDeviceGroup,
    restartDeviceGroup,
    shutdownDeviceGroup,
    rebootDeviceGroup,
    getDeviceGroup,
  } = useDeviceGroup();
  const { addDevice: addDeviceApi } = useDevice();
  const { deviceTypes } = useDeviceTypes();

  const [expanded, setExpanded] = useState(false);
  const [groupRestart, setGroupRestart] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [shutdownModalOpen, setShutdownModalOpen] = useState(false);
  const [rebootModalOpen, setRebootModalOpen] = useState(false);
  const [restartModalOpen, setRestartModalOpen] = useState(false);
  const [addDeviceModalOpen, setAddDeviceModalOpen] = useState(false);
  const [newDeviceName, setNewDeviceName] = useState('');
  const [newDeviceType, setNewDeviceType] = useState('');
  const [newDeviceConnectedTo, setNewDeviceConnectedTo] = useState('');

  const { deviceGroup } = getDeviceGroup(props.did);
  const groupDevices = deviceGroup?.devices || [];
  const hostDevice = groupDevices.find((d: any) => d.deviceTypes?.id === DeviceTypeId.HOST);
  const screenWidth = useCheckMobileScreen();

  // const deviceGroupId = deviceGroups?.filter((id) => id.id == props.did);
  const deviceGroupId = props.did;

  const openAddDeviceModal = () => {
    setAddDeviceModalOpen(true);
  };

  const handleAddDevice = () => {
    if (newDeviceName && newDeviceType) {
      addDeviceApi({
        name: newDeviceName,
        deviceTypeId: parseInt(newDeviceType),
        deviceGroupId: parseInt(props.did),
        connectedTo: newDeviceConnectedTo ? parseInt(newDeviceConnectedTo) : null,
      });
      setAddDeviceModalOpen(false);
      setNewDeviceName('');
      setNewDeviceType('');
      setNewDeviceConnectedTo('');
    }
  };
  // HANDLE RESTART DEVICE GROUP (restarts nexus service)
  const handleRestartDeviceGroup = () => {
    restartDeviceGroup(deviceGroupId);
    setRestartModalOpen(false);
  };
  // HANDLE SHUTDOWN DEVICE GROUP (shuts down host OS)
  const handleShutdownDeviceGroup = () => {
    shutdownDeviceGroup(deviceGroupId);
    setShutdownModalOpen(false);
  };
  // HANDLE REBOOT DEVICE GROUP (reboots host OS)
  const handleRebootDeviceGroup = () => {
    rebootDeviceGroup(deviceGroupId);
    setRebootModalOpen(false);
  };
  const toggle = () => {
    setExpanded(!expanded);
  };
  const showModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const handleDeleteDeviceGroup = (id) => {
    console.log(id);
    deleteDeviceGroup(id)
      .then((data: any) => {
        console.log(data);
      })
      .catch((error: any) => {
        toasti(error);
      });
    closeModal();
  };

  const openConsole = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  const dragDevice = (e: React.MouseEvent<HTMLElement>) => {
    alert("test");
    e.stopPropagation();
  };

  const onClose = () => {
    setModalOpen(false);
  };

  // Error handle in toastify component

  const ErrorMessage = ({ error }) => <div>{error}</div>;
  const toasti = (error) => {
    toast.error(<ErrorMessage error={error} />, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div className="group-container">
      <div className="group-header">
        <div className="list-item-title">
          {/* When we implement device group settings than enable this and remove p tag with props.title  */}
          {/* <NavLink to={`/groups/${props.did}`} className="device-status">
            {props.title}
          </NavLink> */}
          <p style={{ margin: "0", padding: "0" }} className="device-status">
            {props.title}
          </p>
        </div>
        <div className="list-item-actions">
          {screenWidth ? (
            <Tooltip content="Add new device">
              <AddButton
                icon={<AddItemIcon />}
                onClick={openAddDeviceModal}
              />
            </Tooltip>
          ) : (
            <AddButton
              icon={<AddItemIcon />}
              onClick={openAddDeviceModal}
              label="New device"
            />
          )}

          <Tooltip content="To be implemented">
            <ActionButton
              icon={<SettingsIcon />}
              onClick={openConsole}
              className={`list-item-action ${props.status && "online"}`}
            />
          </Tooltip>

          <Tooltip content="Shutdown host">
            <ActionButton
              icon={<PowerIcon />}
              onClick={() => setShutdownModalOpen(true)}
              className="list-item-action shutdown-action"
            />
          </Tooltip>
          <Tooltip content="Reboot host">
            <ActionButton
              icon={<RebootIcon />}
              onClick={() => setRebootModalOpen(true)}
              className="list-item-action reboot-action"
            />
          </Tooltip>
          <Tooltip content="Restart nexus service">
            <ActionButton
              icon={<RestartIcon />}
              onClick={() => setRestartModalOpen(true)}
              className="list-item-action restart-action"
            />
          </Tooltip>
          {hostDevice && (
            <Tooltip content="View logs">
              <NavLink to={`/devices/${hostDevice.id}/logs`}>
                <ActionButton
                  icon={<ConsoleIcon />}
                  className="list-item-action logs-action"
                />
              </NavLink>
            </Tooltip>
          )}
          <ActionButton
            icon={<DeleteIcon />}
            onClick={showModal}
            className="list-item-action"
          />

          {/* <ActionButton icon={<DeleteIcon />} onClick={deleteDevice} className="list-item-action"/>
                    {modalOpen && <Modal title={`Delete ${props.title}?`} warning="Warning: this can't be undone" desc="By deleting device you're deleting all data related to device" closeModal={closeModal} />}
                    {modalOpen && <Modal title={`Delete controller?`} warning="Warning: this can't be undone" desc="By deleting device you're deleting all data related to device" closeModal={closeModal} />} */}
        </div>
      </div>
      <div className="group-body">{props.children}</div>
      {/* Add Device Modal */}
      {addDeviceModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setAddDeviceModalOpen(false)}
        >
          <div
            style={{
              background: '#21282c',
              border: '2px solid #53bde4',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 0 60px rgba(83, 189, 228, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid rgba(83, 189, 228, 0.3)',
            }}>
              <h2 style={{
                margin: 0,
                color: '#53bde4',
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}>
                Add New Device
              </h2>
              <button
                onClick={() => setAddDeviceModalOpen(false)}
                style={{
                  background: 'transparent',
                  border: '2px solid #dc3545',
                  borderRadius: '8px',
                  color: '#dc3545',
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ✕
              </button>
            </div>

            {/* Device Name Input */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                color: '#53bde4',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}>
                Device Name
              </label>
              <input
                type="text"
                value={newDeviceName}
                onChange={(e) => setNewDeviceName(e.target.value)}
                placeholder="Enter device name..."
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: '#242424',
                  border: '2px solid rgba(83, 189, 228, 0.3)',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '1rem',
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            {/* Device Type Select */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                color: '#53bde4',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}>
                Device Type
              </label>
              <select
                value={newDeviceType}
                onChange={(e) => setNewDeviceType(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: '#242424',
                  border: '2px solid rgba(83, 189, 228, 0.3)',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '1rem',
                  outline: 'none',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <option value="">Select a device type...</option>
                {deviceTypes && deviceTypes.map((type: any) => (
                  <option key={type.id} value={type.id} style={{ background: '#21282c' }}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Connected To Select */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                color: '#53bde4',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}>
                Connected To (Optional)
              </label>
              <select
                value={newDeviceConnectedTo}
                onChange={(e) => setNewDeviceConnectedTo(e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: '#242424',
                  border: '2px solid rgba(83, 189, 228, 0.3)',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '1rem',
                  outline: 'none',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <option value="">None (standalone device)</option>
                {groupDevices.map((device: any) => (
                  <option key={device.id} value={device.id} style={{ background: '#21282c' }}>
                    {device.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'flex-end',
            }}>
              <button
                onClick={() => {
                  setAddDeviceModalOpen(false);
                  setNewDeviceName('');
                  setNewDeviceType('');
                  setNewDeviceConnectedTo('');
                }}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddDevice}
                disabled={!newDeviceName || !newDeviceType}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: (!newDeviceName || !newDeviceType)
                    ? 'rgba(83, 189, 228, 0.2)'
                    : 'linear-gradient(135deg, rgba(83, 189, 228, 0.4) 0%, rgba(83, 189, 228, 0.2) 100%)',
                  border: '2px solid #53bde4',
                  borderRadius: '8px',
                  color: '#53bde4',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: (!newDeviceName || !newDeviceType) ? 'not-allowed' : 'pointer',
                  opacity: (!newDeviceName || !newDeviceType) ? 0.5 : 1,
                }}
              >
                Add Device
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Device Group Modal */}
      {modalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={onClose}
        >
          <div
            style={{
              background: '#21282c',
              border: '2px solid #dc3545',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 0 60px rgba(220, 53, 69, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid rgba(220, 53, 69, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                  fontSize: '2rem',
                  background: 'rgba(220, 53, 69, 0.2)',
                  padding: '0.5rem',
                  borderRadius: '8px',
                  border: '1px solid rgba(220, 53, 69, 0.4)',
                }}>
                  🗑️
                </div>
                <div>
                  <h2 style={{
                    margin: 0,
                    color: '#dc3545',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  }}>
                    Delete {props.title}?
                  </h2>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: '#ffc107',
                    fontSize: '0.85rem',
                  }}>
                    Warning: this can't be undone
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                style={{
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ✕
              </button>
            </div>
            <p style={{ color: '#adb5bd', marginBottom: '1.5rem' }}>
              By deleting the device group you're deleting all devices related to device group
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={onClose}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => handleDeleteDeviceGroup(deviceGroupId)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.4) 0%, rgba(220, 53, 69, 0.2) 100%)',
                  border: '2px solid #dc3545',
                  borderRadius: '8px',
                  color: '#dc3545',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 0 20px rgba(220, 53, 69, 0.4)',
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Shutdown Modal */}
      {shutdownModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setShutdownModalOpen(false)}
        >
          <div
            style={{
              background: '#21282c',
              border: '2px solid #dc3545',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 0 60px rgba(220, 53, 69, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid rgba(220, 53, 69, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                  fontSize: '2rem',
                  background: 'rgba(220, 53, 69, 0.2)',
                  padding: '0.5rem',
                  borderRadius: '8px',
                  border: '1px solid rgba(220, 53, 69, 0.4)',
                }}>
                  ⏻
                </div>
                <div>
                  <h2 style={{
                    margin: 0,
                    color: '#dc3545',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  }}>
                    Shutdown {props.title}?
                  </h2>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: '#ffc107',
                    fontSize: '0.85rem',
                  }}>
                    Warning: This will power off the host device
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShutdownModalOpen(false)}
                style={{
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ✕
              </button>
            </div>
            <p style={{ color: '#adb5bd', marginBottom: '1.5rem' }}>
              The device will need to be manually powered on again
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShutdownModalOpen(false)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleShutdownDeviceGroup}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.4) 0%, rgba(220, 53, 69, 0.2) 100%)',
                  border: '2px solid #dc3545',
                  borderRadius: '8px',
                  color: '#dc3545',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 0 20px rgba(220, 53, 69, 0.4)',
                }}
              >
                Shutdown
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reboot Modal */}
      {rebootModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setRebootModalOpen(false)}
        >
          <div
            style={{
              background: '#21282c',
              border: '2px solid #ffc107',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 0 60px rgba(255, 193, 7, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid rgba(255, 193, 7, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                  fontSize: '2rem',
                  background: 'rgba(255, 193, 7, 0.2)',
                  padding: '0.5rem',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 193, 7, 0.4)',
                }}>
                  🔄
                </div>
                <div>
                  <h2 style={{
                    margin: 0,
                    color: '#ffc107',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  }}>
                    Reboot {props.title}?
                  </h2>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: '#6c757d',
                    fontSize: '0.85rem',
                  }}>
                    This will restart the host device
                  </p>
                </div>
              </div>
              <button
                onClick={() => setRebootModalOpen(false)}
                style={{
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ✕
              </button>
            </div>
            <p style={{ color: '#adb5bd', marginBottom: '1.5rem' }}>
              The device will be temporarily unavailable during reboot
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setRebootModalOpen(false)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleRebootDeviceGroup}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.4) 0%, rgba(255, 193, 7, 0.2) 100%)',
                  border: '2px solid #ffc107',
                  borderRadius: '8px',
                  color: '#ffc107',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 0 20px rgba(255, 193, 7, 0.4)',
                }}
              >
                Reboot
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Restart Nexus Service Modal */}
      {restartModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setRestartModalOpen(false)}
        >
          <div
            style={{
              background: '#21282c',
              border: '2px solid #17a2b8',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '500px',
              width: '90%',
              boxShadow: '0 0 60px rgba(23, 162, 184, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1.5rem',
              paddingBottom: '1rem',
              borderBottom: '2px solid rgba(23, 162, 184, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{
                  fontSize: '2rem',
                  background: 'rgba(23, 162, 184, 0.2)',
                  padding: '0.5rem',
                  borderRadius: '8px',
                  border: '1px solid rgba(23, 162, 184, 0.4)',
                }}>
                  🔁
                </div>
                <div>
                  <h2 style={{
                    margin: 0,
                    color: '#17a2b8',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  }}>
                    Restart Nexus Service?
                  </h2>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: '#6c757d',
                    fontSize: '0.85rem',
                  }}>
                    {props.title}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setRestartModalOpen(false)}
                style={{
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '1.5rem',
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                ✕
              </button>
            </div>
            <p style={{ color: '#adb5bd', marginBottom: '1.5rem' }}>
              The connection will be temporarily lost and automatically reconnect
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setRestartModalOpen(false)}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'transparent',
                  border: '2px solid #6c757d',
                  borderRadius: '8px',
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleRestartDeviceGroup}
                style={{
                  padding: '0.75rem 1.5rem',
                  background: 'linear-gradient(135deg, rgba(23, 162, 184, 0.4) 0%, rgba(23, 162, 184, 0.2) 100%)',
                  border: '2px solid #17a2b8',
                  borderRadius: '8px',
                  color: '#17a2b8',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 0 20px rgba(23, 162, 184, 0.4)',
                }}
              >
                Restart Service
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        autoClose={5000}
        position="bottom-right"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default GroupListItem;
